import React from "react";
import stylesV2 from "./SmsCheckbox.module.scss";
import stylesV3 from "./SmsCheckboxV2.module.scss";
import { useSchedulingABVariant } from "../../features/scheduling/utils/useSchedulingABVariant";
import { Checkbox, CheckboxProps } from "components/Checkbox";

interface SmsCheckboxProps extends CheckboxProps {
  label: string;
  labelType?: string;
}

export const SmsCheckbox = React.forwardRef<HTMLInputElement, SmsCheckboxProps>(
  ({ label, ...inputProps }, ref) => {
    const styles = useSchedulingABVariant().isV3 ? stylesV3 : stylesV2;
    return (
      <label className={styles.label}>
        <span className={styles.checkboxContainer}>
          <Checkbox ref={ref} theme="light" {...inputProps} />
        </span>
        <div
          className={styles.text}
          dangerouslySetInnerHTML={{ __html: label }}
        ></div>
      </label>
    );
  }
);
